import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import * as qs from 'querystring';
import axios from 'axios';

const styles = theme => ({
  root: {
    flexGrow: 1,
    maxWidth: 600,
    padding: theme.spacing.unit * 2,
    margin: 'auto',
    marginTop: '2em',
  },
  button: {
    background: '#00eb82',
  },
  img: {
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
  },
});

class Unsubscribe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading : true,
      redirect_url : null,
      broadcast_id : '',
      contact_id : '',
      user_data: {},
      unsubscribed: false,
      error: false,
    };
  }

  // Life Cycle Methods
  // Mounting operatiions
  componentDidMount(){
    this.prepare_unsubscribe();
  }

  async prepare_unsubscribe() {
    // this.setState({loading: true})
    const url_string = this.props.location.search.split('?')[1];
    const query_obj = await qs.parse(url_string);
    const broadcast_id = query_obj['mid'].split('-')[0];
    const contact_id = query_obj['mid'].split('-')[1];

    const params = {
      broadcast_id: broadcast_id,
      contact_id: contact_id
    };
    let user_data = await axios('/unsubscribe/get_client_info', {params: params});
    this.setState({ 
      user_data: user_data['data'], 
      broadcast_id : broadcast_id, 
      contact_id : contact_id, 
      loading: false
    });
  }

  async onClick() {
    const { broadcast_id, contact_id } = this.state;
    const unsub_obj = {
      'broadcast_id': broadcast_id,
      'contact_id' : contact_id,
      'activity' : 'Optout'
    };
    const unsubscribe_response = await axios.post('/unsubscribe/unsubscribe', unsub_obj);
    if (unsubscribe_response.data === 200) {
      this.setState({unsubscribed : true});
    } else {
      this.setState({error: true});
      setTimeout(() => {
        this.setState({error: false});
        this.prepare_unsubscribe();
      }, 5000);
    }
  }

  // Updating operations
  shouldComponentUpdate(nextProps, nextState){
    // Will not trigger render() if returns false
    if (
      this.state.loading !== nextState.loading || 
      this.state.unsubscribed !== nextState.unsubscribed ||
      this.state.error !== nextState.error
    ){
      return true;
    } else {
      return false;
    }
  }

  componentDidUpdate(){
  }

  // Unmounting Operations
  componentWillUnmount(){
  }

  render(){
    const { classes } = this.props;
    const { loading, user_data, unsubscribed, error } = this.state;
    return(
      <Paper className={classes.root}>
        { loading ? <Typography>Gathering Email Information...</Typography> :
          unsubscribed ? <Typography>You have successfully been unsubscribed.</Typography> :
            error ? <Typography>There was an error processing your request, you will be redirected to the previous page. </Typography> :
              <Grid container spacing={16}>
                <Grid item>
                  <Button className={classes.button} variant='extendedFab' onClick={() => this.onClick()}>
                    Confirm
                  </Button>
                </Grid>
                <Grid item xs={12} sm container>
                  <Grid item xs container direction="column" spacing={16}>
                    <Grid item xs>
                      <Typography gutterBottom variant="subheading">
                        { user_data.email !== null ? `${user_data.email} is ` : 'You are ' }
                        about to unsubscribe from
                        { user_data.account_name !== null ? ` the ${user_data.account_name} ` : ' this ' }
                        mailing list.
                      </Typography>
                      <Typography>
                        Press Confirm to unsubscribe.
                      </Typography>
                      { user_data.parent_email_flag ? 
                        <Typography gutterBottom>
                          <br />
                          Note: this will unsubscribe you from future emails related to this student.<br />
                          If other students list your email you will continue to receive those messages.
                        </Typography>
                        : null }    
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
        }
      </Paper>
    );
  }
}

Unsubscribe.propTypes = {
  location: PropTypes.object,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Unsubscribe);



// WEBPACK FOOTER //
// ./src/client/views/unsubscribe.js